import { TableCell, TableRow } from "@mui/material";
import dele from "../../../../assets/DigitalMarketing/image/delete.svg";
import edit from "../../../../assets/DigitalMarketing/image/edit.svg";
import eye from "../../../../assets/DigitalMarketing/image/visibility.svg";
import { useEffect, useState } from "react";
import IosSwitchBtn from "../../../../Component/DigitalMarketing/IosSwitchbtn";
import useDeleteBox from "../../../../hooks/digitalMarketing/useDeleteBox";
import AlertDialog from "../../../../Component/DigitalMarketing/deleteConfirmation";
import {
  useDeleteProcedureMutation,
  useUpdateProcedureMutation,
} from "../../../../Service/Masters";
import Pagination from "../../../../Component/DigitalMarketing/Pagination";

const TableList = (props) => {
  const { procedureData, setShow, setUpdateData, setView, refetch } = props;
  const [deleteProcedure] = useDeleteProcedureMutation();
  const [updateProcedure] = useUpdateProcedureMutation();
  const { open, message, openDelete, deleteId } = useDeleteBox();
  const [checkedStates, setCheckedStates] = useState([]);

  const handleChange = (index: any, id: number) => (event) => {
    const newCheckedStates = [...checkedStates];
    newCheckedStates[index] = event?.target?.checked;
    setCheckedStates(newCheckedStates);

    updateProcedureStatus(id, event.target.checked);
  };

  const updateProcedureStatus = async (id, status) => {
    await updateProcedure({ id, activeStatus: status ? "1" : "0" });
    refetch();
  };

  const handleUpdate = (data) => {
    setView(false);
    setShow(true);
    setUpdateData(data);
  };

  const handleView = (data) => {
    setView(true);
    setShow(true);
    setUpdateData(data);
  };

  console.log(setUpdateData);

  const deleteBranches = async (bool) => {
    if (bool) {
      await deleteProcedure(deleteId);
      refetch();
    }
    openDelete("Are you sure you want to delete this Procedure?", false, null);
  };

  useEffect(() => {
    if (procedureData?.data) {
      setCheckedStates(
        procedureData.data.map((procedure) => procedure?.activeStatus === 1)
      );
    }
  }, [procedureData]);

  return (
    <>
      <AlertDialog
        open={open}
        message={message}
        deleteBranches={deleteBranches}
      />
      {procedureData?.data?.length > 0 ? (
        procedureData.data.map((procedure, index) => (
          <TableRow key={procedure.id} role="checkbox">
            <TableCell align="left">{index + 1}</TableCell>
            <TableCell align="left">{procedure.procedureTitle}</TableCell>
            <TableCell align="left">{procedure.price}</TableCell>
            <TableCell align="left">{procedure.cgst} %</TableCell>
            <TableCell align="left">{procedure.sgst} %</TableCell>
            <TableCell align="left">
              <IosSwitchBtn
                onChange={handleChange(index, procedure.id)}
                checked={
                  checkedStates[index] !== undefined
                    ? checkedStates[index]
                    : false
                }
                label={checkedStates[index] ? "Active" : "Inactive"}
              />
            </TableCell>
            <TableCell align="left">
              <img
                src={edit}
                alt="edit"
                className="blue-c action-icon cursor"
                onClick={() => handleUpdate(procedure)}
              />
              <img
                src={dele}
                alt="delete"
                className="delete-icon cursor action-icon ms-2"
                onClick={() =>
                  openDelete(
                    "Are you sure you want to delete this procedure templates?",
                    true,
                    procedure.id
                  )
                }
              />
              <img
                src={eye}
                alt="view"
                className="view-icon cursor action-icon ms-2"
                onClick={() => handleView(procedure)}
              />
            </TableCell>
          </TableRow>
        ))
      ) : (
        <TableRow>
          <TableCell colSpan={6} align="center">
            No data available.
          </TableCell>
        </TableRow>
      )}
    </>
  );
};

export default TableList;
